import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLMeterElement extends HTMLElement { constructor(tagName: string = 'METER', ownerDocument?: any) { super(tagName, ownerDocument); } }
